module.exports = __webpack_public_path__ + "static/media/ic_recharge_history.8f94a540.png";